import { defineStore } from 'pinia';
import axiosInstance from '@/services/axiosInstance';
import { IMessage } from '@/types';

export const useMessageStore = defineStore('messageStore', {
  state: () => ({
    messages: [] as IMessage[],
    unreadCount: 0,
    loading: false,
    error: null as string | null,
  }),
  actions: {
    async fetchMessages() {
      this.loading = true;
      this.error = null;
      try {
        const response = await axiosInstance.get('/messages');
        this.messages = response.data;
      } catch (err: any) {
        this.error = err.message || 'Failed to fetch messages';
        console.error('Error fetching messages:', err);
      } finally {
        this.loading = false;
      }
    },
    async fetchUnreadCount() {
      try {
        const response = await axiosInstance.get('/messages/unread-count');
        this.unreadCount = response.data.count;
      } catch (err) {
        console.error('Error fetching unread count:', err);
      }
    },
    async sendMessage(payload: Partial<IMessage>) {
      try {
        const response = await axiosInstance.post('/messages', payload);
        return response.data;
      } catch (err: any) {
        console.error('Error sending message:', err);
        throw err;
      }
    },
    async markAsRead(id: string) {
      try {
        await axiosInstance.put(`/messages/${id}/read`);
        const message = this.messages.find(m => m._id === id);
        if (message && !message.isRead) {
          message.isRead = true;
          this.unreadCount = Math.max(0, this.unreadCount - 1);
        }
      } catch (err) {
        console.error('Error marking message as read:', err);
      }
    },
    async deleteMessage(id: string) {
      try {
        await axiosInstance.delete(`/messages/${id}`);
        this.messages = this.messages.filter(m => m._id !== id);
      } catch (err) {
        console.error('Error deleting message:', err);
      }
    }
  },
  getters: {
    sortedMessages: (state) => {
      return [...state.messages].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    }
  }
});
